export { VpVideoCaptionPlayer } from './VpVideoCaptionPlayer';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpVideoCaptionPlayer/index.js